// extracted by mini-css-extract-plugin
module.exports = {"subheading":"subheading_subheading__175ey"};